import { EventEntry } from "@/src/constants/mock-events.constant";
import * as FileSystem from "expo-file-system/legacy";
import * as Sharing from "expo-sharing";
import { Platform } from "react-native";
import { utils, write } from "xlsx";

type ParticipantStatus = "attending" | "waitlisted";

const EXCEL_SHEET_NAME = "Participants";
const EXCEL_MIME_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
const EXCEL_UTI = "com.microsoft.excel.xlsx";

const EXCEL_COLUMN_WIDTHS = [
  { wch: 24 },
  { wch: 30 },
  { wch: 14 },
  { wch: 16 },
  { wch: 8 },
];

export const exportParticipantsToExcel = async (
  event: EventEntry,
  participantStatus: ParticipantStatus,
): Promise<void> => {
  const rows = (event?.participants ?? [])
    .filter((participant) => participant?.attendingStatus === participantStatus)
    .map((participant) => ({
      Name: participant?.displayName,
      Email: participant?.email,
      Status: participant?.attendingStatus,
      Guests: participant?.guestCount ?? 0,
    }));

  const worksheet = utils.json_to_sheet(rows);
  worksheet["!cols"] = EXCEL_COLUMN_WIDTHS;

  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, EXCEL_SHEET_NAME);

  const fileName = `${event?.title.replace(/\s+/g, "_")}_participants.xlsx`;

  if (Platform.OS === "web") {
    const buffer = write(workbook, { type: "array", bookType: "xlsx" });
    const blob = new Blob([buffer], { type: EXCEL_MIME_TYPE });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();
    URL.revokeObjectURL(url);
    return;
  }

  const base64 = write(workbook, { type: "base64", bookType: "xlsx" });
  const fileUri = `${FileSystem.cacheDirectory}${fileName}`;

  await FileSystem.writeAsStringAsync(fileUri, base64, {
    encoding: "base64",
  });

  await Sharing.shareAsync(fileUri, {
    mimeType: EXCEL_MIME_TYPE,
    dialogTitle: `Export ${fileName}`,
    UTI: EXCEL_UTI,
  });
};
